import type { ProductColor } from '@aloft/toolkit-shared';
import { Block } from '@aloft/toolkit-sui';

import { PROPERTY_HEADER_COLOR_BAND_HEIGHT } from '../../PropertyGrid/consts.ts';

type Props = {
  color: ProductColor;
};

export const ValuationTablePropertyHeaderColorBand = ({ color }: Props) => (
  <Block width="100%" height={PROPERTY_HEADER_COLOR_BAND_HEIGHT} backgroundColor={color} />
);
